export const Roles = {
  Admin: 'Admin',
  CompanyOperator: 'Operator',
  CompanyAdmin: 'Company Admin',
  Agent: 'Agent',
  Customer: 'Customer'
};

export const RoleNames = {
  Admin: 'Admin',
  CompanyOperator: 'Operator',
  CompanyAdmin: 'Company Admin',
  Agent: 'Agent',
  Customer: 'Customer'
};
